import { render, staticRenderFns } from "./Analitics.vue?vue&type=template&id=3f544ad8&scoped=true"
import script from "./Analitics.vue?vue&type=script&lang=js"
export * from "./Analitics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f544ad8",
  null
  
)

export default component.exports